import {
  BOOKING_DATA_RECEIVED,
  PROMOCODE_DATA_RECEIVED,
  BOOKING_LOADER,
  CARD_LIST,
  CARD_LOADER,
  WALLET_LOADER,
  WALLET_DATA_RECEIVED,
  SET_HOME_STAY,
  SET_HOME_INSTRUCTION,
  ADDEDIMAGE1,
  ADDEDIMAGE2,
  ADDEDIMAGE3,
  ADDEDIMAGE4,
  HOME_AVALABLE,
} from "./types";
import {
  bookingList,
  providerBookingList,
  mousamproviderTodayBookingList,
  mousamproviderAllBookingList,
  mousamproviderTodayOtherBookingList,
  bookingTimeSlot,
  promoCodeList,
  checkPromoCode,
  cardList,
  bookingDetail,
  getRecurringBookings,
} from "../apiHelpers/booking/list";
import {
  createBooking,
  payViaCard,
  cardAdd,
  getStripeTokenWithoutAmount,
  deleteCard,
  walletAmountAdd,
  walletPay,
  rateBooking,
  acceptBooking,
  rejectBooking,
  completeBooking,
  approvePaymentBooking,
  cancelBooking,
  cancelsp,
  reBooking,
  acceptAvailableService,
} from "../apiHelpers/booking/create";
import { walletListAction, getLoggedInUserAction } from "./User";

export const bookingListAction = (params) => async (dispatch, getState) => {
  dispatch({ type: BOOKING_LOADER, payload: true });
  const response = await bookingList(params);
  if (response.status == "OK") {
    if (params.append) {
      const newData = response.data.bookingList;
      const oldData = getState().bookings.bookingData.bookingList;
      const finalData = {};
      finalData.bookingList = [...oldData, ...newData];

      dispatch({
        type: BOOKING_DATA_RECEIVED,
        payload: finalData,
      });
    } else {
      dispatch({
        type: BOOKING_DATA_RECEIVED,
        payload: response.data,
      });
    }
    dispatch({ type: BOOKING_LOADER, payload: false });
  }
};

export const recurringBookingListAction = (done) => async (dispatch) => {
  const apiData = await getRecurringBookings();
  if (apiData.status == "OK") {
    done(true, apiData.data);
  } else {
    done(false, apiData.message);
  }
};

export const mousamproviderTodayBookingListAction = (done) => async (dispatch, getState) => {
  console.log("2222222222222222222222222222222")
  const finalData = {};
  const apiData = await mousamproviderTodayBookingList();
  if (apiData.status == "OK") {
    console.log("555555555555555555555555555555555555555555555555", apiData.data.bookingList)
    finalData.bookingList = [...apiData.data.bookingList];
    dispatch({
      type: BOOKING_DATA_RECEIVED,
      payload: finalData,
    });

  } else {
    // done(false, apiData.message);
  }
}

export const mousamproviderTodayOtherBookingListAction = (done) => async (dispatch, getState) => {
  console.log("2222222222222222222222222222222")
  // alert("before mp "+done.type+" -- "+BOOKING_DATA_RECEIVED)
  const finalData = {};
  const apiData = await mousamproviderTodayOtherBookingList(done.type);
  if (apiData.status == "OK") {
    console.log("555555555555555555555555555555555555555555555555", apiData.data.bookingList)
    finalData.bookingList = [...apiData.data.bookingList];
    dispatch({
      type: BOOKING_DATA_RECEIVED,
      payload: finalData,
    });

  } else {
    // done(false, apiData.message);
  }
}

export const mousamproviderAllBookingListAction = (done) => async (dispatch, getState) => {
  console.log("2222222222222222222222222222222")
  const finalData = {};
  const apiData = await mousamproviderAllBookingList();
  if (apiData.status == "OK") {
    console.log("555555555555555555555555555555555555555555555555", apiData.data.bookingList)
    finalData.bookingList = [...apiData.data.bookingList];
    dispatch({
      type: BOOKING_DATA_RECEIVED,
      payload: finalData,
    });

  } else {
    // done(false, apiData.message);
  }
}

export const providerBookingListAction = (params) => async (
  dispatch,
  getState
) => {
  // alert("ppp "+params.type)
  dispatch({ type: BOOKING_LOADER, payload: true });
  params.requested = false;
  if (params.type == 1) {
    params.requested = true;
  }
  const response = await providerBookingList(params);
  if (response.status == "OK") {
    if (params.append) {
      const newData = response.data.bookingList;
      const oldData = getState().bookings.bookingData.bookingList;

      const finalData = {};
      finalData.bookingList = [...oldData, ...newData];

      dispatch({
        type: BOOKING_DATA_RECEIVED,
        payload: finalData,
      });
    } else {
      dispatch({
        type: BOOKING_DATA_RECEIVED,
        payload: response.data,
      });
    }

    dispatch({ type: BOOKING_LOADER, payload: false });
  }
};

export const bookingDetailAction = (params, done) => async (dispatch) => {
  const response = await bookingDetail(params);
  if (response.status == "OK") {
    done(true, response);
  } else {
    done(false, response);
  }
};

export const bookingTimeSlotAction = (params, done) => async (dispatch) => {
  const response = await bookingTimeSlot(params);
  if (response.status == "OK") {
    done(true, response);
  } else {
    done(false, response);
  }
};

export const promoCodeListAction = () => async (dispatch) => {
  const response = await promoCodeList();
  if (response.status == "OK") {
    dispatch({ type: PROMOCODE_DATA_RECEIVED, payload: response.data });
  }
};
export const checkPromoCodeAction = (params, done) => async (dispatch) => {
  const response = await checkPromoCode(params);
  if (response.status == "OK") {
    done(true, response);
  } else {
    done(false, response);
  }
};

export const createBookingAction = (params, done) => async (dispatch) => {
  console.log("Creating booking");
  console.log(
    "Creating bookingXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX",
    params.paymentType,
    params.services[0].service_type
  );
  //   params.services[0].service_type="Package";
  console.log(params);
  const response = await createBooking(params);
  if (response.status == "OK") {
    dispatch(getLoggedInUserAction());
    dispatch(bookingListAction({ append: true }));
    done(true, response);
  } else {
    done(false, response);
  }
};
export const cardListAction = done => async (dispatch) => {
  dispatch({ type: CARD_LOADER, payload: true });
  const response = await cardList();
  console.log("CARDS ON BOOKING", response);
  if (response.status == "OK") {
    dispatch({ type: CARD_LIST, payload: response.data });
    dispatch({ type: CARD_LOADER, payload: false });
    // console.log('cardlistdata.........',response.data.source)
    if (response.data.sources.data.length === 0) {
      done(false, response);
    }
    else {
      done(true, response.data);
    }

  } else {
    console.log('cardlistdata.........', response)
    dispatch({ type: CARD_LOADER, payload: false });
    done(false, response);
  }
};
export const savedCardListAction = (done) => async (dispatch) => {
  const response = await cardList();
  if (response.status == "OK") {
    done(true, response);
  } else {
    done(false, response);
  }
};
export const payViaCardAction = (params, done) => async (dispatch) => {
  const response = await payViaCard(params);
  if (response.status == "OK") {
    done(true, response);
  } else {
    done(false, response);
  }
};

export const cardAddAction = (token, done) => async (dispatch) => {
  // alert("hi")
  // const token = await getStripeTokenWithoutAmount(params);
  if (token) {
    console.log("TTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTT", token)

    const response = await cardAdd({ stripeToken: token });
    console.log("AAAAAAAAAYYYYYYYYYYYYYYYYYAAAAAAAAAAAAAAAAAA", response)

    if (response.status === "OK") {
      dispatch(cardListAction(done));
      return done(true, { message: "Added successfully" });
    }
    return done(false, response.message);
  } else {
    return done(false, { message: "Please enter correct Card Details" });
  }
};

export const deleteCardAction = (params, done) => async (dispatch) => {
  const response = await deleteCard(params);
  if (response.status == "OK") {
    dispatch(cardListAction(done));
    done(true, response);
  } else {
    done(false, response);
  }
};
export const walletAmountAddAction = (params, done) => async (dispatch) => {
  try {
    const response = await walletAmountAdd(params);
    if (response.status === "OK") {
      dispatch(walletListAction());
      dispatch(getLoggedInUserAction());
      return done(true, response);
    } else {
      return done(false, response);
    }
  } catch (e) {
    console.log(e);
    done(false, e.message);
  }
};

export const walletPayAction = (params, done) => async (dispatch) => {
  try {
    const response = await walletPay(params);
    if (response.status === "OK") {
      return done(true, response);
    } else {
      return done(false, response);
    }
  } catch (e) {
    console.log(e);
    done(false, e.message);
  }
};
export const rateBookingAction = (params, done) => async (dispatch) => {
  try {
    const response = await rateBooking(params);
    if (response.status === "OK") {
      return done(true, response.data);
    } else {
      return done(false, response.message);
    }
  } catch (e) {
    console.log(e);
    done(false, e.message);
  }
};

export const acceptBookingAction = (params, done) => async (dispatch) => {
  try {
    const response = await acceptBooking(params);
    if (response.status === "OK") {
      return done(true, response);
    }
    done(false, response.message);
  } catch (e) {
    console.log(e);
    done(false, e.message);
  }

};

export const acceptAvailableBookingAction = (params, done) => async (
  dispatch
) => {
  try {
    const response = await acceptAvailableService(params);
    if (response.status === "OK") {
      return done(true, response);
    }
    done(false, response.message);
  } catch (e) {
    console.log(e);
    done(false, e.message);
  }
};

export const rejectBookingAction = (params, done) => async (dispatch) => {
  try {
    const response = await rejectBooking(params);
    if (response.status === "OK") {
      return done(true, response.data);
    }
    done(false, response.message);
  } catch (e) {
    console.log(e);
    done(false, e.message);
  }
};

export const completeBookingAction = (params, done) => async (dispatch) => {
  try {
    const response = await completeBooking(params);
    if (response.status === "OK") {
      return done(true, response.data);
    }
    done(false, response.message);
  } catch (e) {
    console.log(e);
    done(false, e.message);
  }
};

export const approvePaymentBookingAction = (params, done) => async (
  dispatch
) => {
  try {
    const response = await approvePaymentBooking(params);
    if (response.status === "OK") {
      return done(true, response.data);
    }
    done(false, response.message);
  } catch (e) {
    console.log(e);
    done(false, e.message);
  }
};

export const cancelBookingAction = (params, done) => async (dispatch) => {
  try {
    const response = await cancelBooking(params);
    if (response.status === "OK") {
      return done(true, response.data);
    }
    done(false, response.message);
  } catch (e) {
    console.log(e);
    done(false, e.message);
  }
};

export const cancelBookingsp = (params, done) => async (dispatch) => {
  try {
    const response = await cancelsp(params);
    if (response.status === "OK") {
      return done(true, response.data);
    }
    done(false, response.message);
  } catch (e) {
    console.log(e);
    done(false, e.message);
  }
};

export const reBookingAction = (params, done) => async (dispatch) => {
  try {
    const response = await reBooking(params);
    if (response.status == "OK") {
      return done(true, response.data);
    }
    return done(false, response.message);
  } catch (e) {
    console.log(e);
    return done(false, e.getMessage());
  }
};


export const setHomeStayAction = (params) => async (dispatch) => {
  console.log("aa", params)
  try {
    dispatch({
      type: SET_HOME_STAY,
      payload: params,
    });
  } catch (e) {
    console.error(e);
  }
};

export const setHomeInstructionAction = (params) => async (dispatch) => {
  console.log("params data", params)
  try {
    dispatch({
      type: SET_HOME_INSTRUCTION,
      payload: params,
    })
  } catch (e) {
    console.error(e);
  }
};

export const setHomeAvailableAction = (params) => async (dispatch) => {
  try {
    dispatch({
      type: HOME_AVALABLE,
      payload: params,
    });
  } catch (e) {
    console.error(e);
  }
};

export const setAddedImage1Action = (params) => async (dispatch) => {
  try {
    dispatch({
      type: ADDEDIMAGE1,
      payload: params,
    });
  } catch (e) {
    console.error(e);
  }
};

export const setAddedImage2Action = (params) => async (dispatch) => {
  try {
    dispatch({
      type: ADDEDIMAGE2,
      payload: params,
    });
  } catch (e) {
    console.error(e);
  }
};

export const setAddedImage3Action = (params) => async (dispatch) => {
  try {
    dispatch({
      type: ADDEDIMAGE3,
      payload: params,
    });
  } catch (e) {
    console.error(e);
  }
};

export const setAddedImage4Action = (params) => async (dispatch) => {
  try {
    dispatch({
      type: ADDEDIMAGE4,
      payload: params,
    });
  } catch (e) {
    console.error(e);
  }
};


// WEBPACK FOOTER //
// ./src/actions/Booking.js